import { Component } from '@angular/core';
import { ModalRef } from '@direct-line-group/fee-ng-components/dist/dlg-walrus';

@Component({
  selector: 'app-cancel-changes-modal',
  templateUrl: './cancel-changes-modal.component.html',
  styleUrls: ['./cancel-changes-modal.component.scss'],
})
export class CancelChangesModalComponent {
  constructor(private modalRef: ModalRef) {}

  onSave() {
    this.modalRef.close('save');
  }

  onCancel() {
    this.modalRef.close('cancel');
  }
}
